import { render, staticRenderFns } from "./stasi.vue?vue&type=template&id=037de221&"
import script from "./stasi.vue?vue&type=script&lang=js&"
export * from "./stasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports